export const convertProductIdToName = (productTypeId: number) => {
    switch (productTypeId) {
        case 195:
            return "Tradesman Liability";
        case 196:
            return "Small Business & Consultants Liability";
        case 197:
            return "Contractors All Risks";
        case 198:
            return "Shop Insurance";
        case 201:
            return "Goods in Transit Courier";
        case 202:
            return "Goods in Transit";
        case 203:
            return "Property Owners";
        case 207:
            return "Commercial Office";
        case 208:
            return "Hauliers Choice";
        case 209:
            return "Professional Indemnity";
        case 313:
            return "Business Support";
        case 326:
            return "Excess Waiver";
        case 331:
            return "Landlord in Residence and Tenants Contents";
        case 306:
            return "Turnover";
        case 346:
            return "Residential Property Owners";
        default:
            break;
    }
    return "";
}

export const convertProductIdToWebReference = (productTypeId: number) => {
    var siteConfig = JSON.parse(localStorage.getItem('siteConfig') || "");
    switch (productTypeId) {
        case 195:
            return `${siteConfig.activeSite}TL`;
        case 196:
            return `${siteConfig.activeSite}SC`;
        case 197:
            return `${siteConfig.activeSite}CA`;
        case 198:
            return `${siteConfig.activeSite}SI`;
        case 203:
            return `${siteConfig.activeSite}PO`;
        case 209:
            return `${siteConfig.activeSite}PI`;
        case 346:
            return `${siteConfig.activeSite}RPO`;
        default:
            break;
    }
    return "";
}